<div class="contenedor">
    <input type="checkbox" id="toggle">
    <label for="toggle" class="button"></label>
    <nav class="nav">
      <a style="cursor: pointer;" (click)="exportar()">Exportar CSV &nbsp;<i class="far fa-file-excel"></i></a>
    </nav>
  </div>